import {
    type TFunction,
} from 'i18next'

import {
    type ApiValidationError,
} from './api-error'

export function translateValidationError(
    error: ApiValidationError,
    field: string,
    t: TFunction,
): string {
    return t(
        error.code as never,
        {
            field,
            ...error.parameters,
            defaultValue: error.message,
        },
    )
}